import { Payload, Types } from 'states/dux/document/types'
import { Action } from 'states/types'

const initialState: Payload = {
  loading: true,
  data: [],
  selectedData: undefined
}

const reducer = (state = initialState, action: Action<Payload>): Payload => {
  const { type, payload } = action
  switch (type) {
    case Types.SET: {
      return payload
    }
    case Types.ADD: {
      const data = [...state.data]
      data.push(payload.data[0])

      return { ...state, data }
    }
    case Types.UPDATE: {
      const newStateData = state.data.map(element => {
        if (element.id === payload.data[0].id) {
          return payload.data[0]
        }
        return element
      })

      return { ...state, data: newStateData }
    }
    case Types.LOADING: {
      return { ...state, loading: payload.loading }
    }
    case Types.SETTERS: {
      return { ...state, selectedData: payload.selectedData }
    }
    default:
      return state
  }
}

export { reducer }

export default reducer
